import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/engage",
        name: "engage",
        component: () => import("@/views/modules/engage/engage.vue"),
        redirect: "/engage/list",
        meta: {
            contentClass: "module-engage",
            resource: "engage",
            action: "read",
        },
        children: [
            {
                path: "/engage/list",
                name: "engage-list",
                component: () => import("@/views/modules/engage/list/engageList.vue"),
                meta: {
                    contentClass: "module-engage",
                    resource: "engage",
                    action: "read",
                },
                beforeEnter: isUserLoggedIn,
            },
            {
                path: "/engage/list/:id",
                name: "engage-list-element",
                component: () => import("@/views/modules/engage/list/engageOverview.vue"),
                meta: {
                    contentClass: "module-engage",
                    resource: "engage",
                    action: "read",
                },
                beforeEnter: isUserLoggedIn,
                props: (route) => ({ id: Number(route.params.id) }),
            },
        ],
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/engage/create",
        name: "engage-create",
        component: () => import("@/views/modules/engage/create/createEngage.vue"),
        meta: {
            contentClass: "module-engage",
            navActiveLink: "engage",
            resource: "engage",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/engage/edit",
        name: "engage-edit",
        component: () => import("@/views/modules/engage/create/createEngage.vue"),
        meta: {
            contentClass: "module-engage",
            navActiveLink: "engage",
            resource: "engage",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
